import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './home/components/Navbar';
import Footer from './home/components/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#fafafa] flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-lg">
          <div className="text-[120px] md:text-[180px] font-black text-gray-200 leading-none select-none">404</div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 -mt-6 mb-4">Page not found</h1>
          <p className="text-gray-500 text-lg mb-10">The page you're looking for doesn't exist or has been moved. Let's get you back on track.</p>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-12">
            <Link to="/" className="px-6 py-3 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 transition-colors text-sm inline-block text-center"
              style={{ boxShadow: '0 4px 12px rgba(37,99,235,0.2)' }}>
              Back to Home
            </Link>
            <Link to="/contact" className="px-6 py-3 bg-white text-gray-700 font-bold rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors text-sm inline-block text-center">
              Contact Support
            </Link>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4">Popular Pages</p>
            <div className="flex flex-wrap gap-2 justify-center">
              {[
                { label: "Pricing", href: "/pricing" },
                { label: "Payments", href: "/products/payments" },
                { label: "Documentation", href: "/developers/docs" },
                { label: "Tapn", href: "/tapn" },
                { label: "Blog", href: "/blog" },
                { label: "Status", href: "/status" },
              ].map(link => (
                <Link key={link.label} to={link.href}
                  className="px-3 py-1.5 text-sm text-gray-600 bg-white border border-gray-100 rounded-lg hover:border-blue-200 hover:text-blue-600 transition-colors">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}